import format from './format';
import defaultLang from './lang/zh-CN';

var _lang = defaultLang;

function use(lang) {
  _lang = lang;
}

function t(path, options) {
  var array = path.split('.');
  var current = _lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    var value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
}

export default {
  use: use,
  t: t
};


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/locale/index.js
// module id = 14
// module chunks = 0